import { BrandingTheme } from '@/types/brandingThemes';

export type ActivationStatusRequest = {
  activation_code: string;
  userGroup: UserGroup;
};

export type ActivationStatusResponse = {
  status: AccountActivationStatus;
  phoneNumber: string;
  companyName: string;
  brandingTheme: BrandingTheme;
};

export enum AccountActivationStatus {
  Valid = 'valid',
  Invalid = 'invalid',
  Expired = 'expired',
  AlreadyActivated = 'already_activated',
}

export type ActivationChallengeValidationRequest = {
  activation_code: string;
  otp_code: string;
};

export type ActivationChallengeValidationResponse = {
  activationStatus: AccountActivationStatus;
  challengeStatus: ChallengeStatus;
  setPasswordCode: string;
  mustSetPassword: boolean;
  isSelfCreated: boolean;
};

export enum ChallengeStatus {
  Valid = 'valid',
  Invalid = 'invalid',
}

export enum PasswordChallengeStatus {
  Valid = 'valid',
  Invalid = 'invalid',
  Expired = 'expired',
}

export type SetPasswordRequest = {
  set_password_code: string;
  password: string;
};

export type SetPasswordResponse = {
  status: PasswordChallengeStatus;
};

export type ResetPasswordRequest = {
  setPasswordCode: string;
  password: string;
};

export type ResendActivationLinkRequest = {
  email: string;
};

export type UserGroup = 'consumer' | 'teammate' | 'staff';

export type InitiateAuthPayload = {
  username: string;
  password: string;
  userGroup: UserGroup;
};

export type InitiateAuthResponse = {
  success: boolean;
  idToken?: string;
  expiresIn: number;
  refreshToken?: string;
  session?: string;
  challenge?: boolean;
  challengePhone?: string;
};

export type AuthChallengeValidationPayload = {
  username: string;
  sms_mfa_code: string;
  session: string;
};

export type AuthChallengeValidationResponse = {
  success: boolean;
  idToken?: string;
  expiresIn: number;
  refreshToken?: string;
};

export type RefreshTokenResponse = {
  success: boolean;
  accessToken: string;
  idToken?: string;
  expiresIn: number;
  expiration?: number;
};

export type StartResetPasswordPaylod = {
  email: string;
};

export type StartResetPasswordResponse = {
  success: boolean;
  idToken?: string;
  expiresIn: number;
  refreshToken?: string;
};

export type ResetPasswordPaylod = {
  email: string;
  userGroup: UserGroup;
};

export type ResetPasswordResponse = {
  status: PasswordChallengeStatus;
};

export type ResetPasswordChallengeValidationPaylod = {
  email: string;
  otp: string;
};

export type ResetPasswordChallengeValidationResponse = {
  success: boolean;
};

export type UpdatePasswordPayload = {
  oldPassword: string;
  newPassword: string;
};

export type UpdatePasswordResponse = {
  success: boolean;
  oldPasswordValidationStatus: boolean;
};

export type StartUpdateEmailPayload = {
  email: string;
};

export type UpdateEmailPayload = {
  email: string;
  otp: string;
};

export type UpdateEmailResponse = {
  success: boolean;
};

export type StartUpdatePhoneNumberPayload = {
  phoneNumber: string;
};

export type UpdatePhoneNumberPayload = {
  phoneNumber: string;
  otp: string;
};

export type UpdatePhoneNumberResponse = {
  success: boolean;
};

export type EnrollForm = {
  firstName: string;
  middleName: string;
  lastName: string;
  phone: string;
  password: string;
  confirmPassword: string;
  email: string;
  advisorId: string;
};

export type UpdateProfileSettingsFormsProps = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};
